import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const PutProposalRejectRequestSchema = z
  .object({
    campaignProposalId: z.number(),
  })
  .describe('PutProposalRejectRequestSchema');

export type PutProposalRejectRequest = z.infer<typeof PutProposalRejectRequestSchema>;

const PutProposalRejectResponseDataSchema = z
  .object({
    campaignProposalId: z.number(),
  })
  .describe('PutProposalRejectResponseDataSchema');

const PutProposalRejectResponseSchema = createApiResponseSchema(
  PutProposalRejectResponseDataSchema,
);

export type PutProposalRejectResponse = z.infer<typeof PutProposalRejectResponseSchema>;

export const putProposalReject = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PutProposalRejectRequestSchema),
    async (params: PutProposalRejectRequest): Promise<PutProposalRejectResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.put<PutProposalRejectResponse>(
          urlJoin(campaignsApiPath.putProposalReject(params.campaignProposalId)),
        );
        return response;
      }),
    validateApiResponse(PutProposalRejectResponseSchema),
  ),
);
